<template>
  <div>
    <el-table :data="tableData" height="300px" highlight-current-row style="width: 100%">
      <el-table-column property="value" :label="skcSpec.name" width="100">
        <template slot="header"> <span style="color: red">*</span>{{ skcSpec.name }} </template>
      </el-table-column>
      <el-table-column property="previewImgUrls">
        <template slot="header"> <span style="color: red">*</span> 轮播图(5-10张，宽高比例为3:4，宽>1340px，高>1785px，小于2M) </template>
        <template slot-scope="{ row, $index }">
          <CarouselImages
            :ref="`carouselImagesRef_${$index}`"
            v-model="row.previewImgUrls"
            :languages="languages"
            :languageMap="languageMap"
            :imgLimits="carouselImagesLimits"
            :autoCropImageParams="autoCropImageParams"
          />
        </template>
      </el-table-column>
      <!-- <el-table-column property="simg" label="色块图" width="120">
        <template slot-scope="{ row }">
          <MutiImgUpload v-model="row.simg" :mainImgNums="0" :limitNums="1" />
        </template>
      </el-table-column> -->
      <el-table-column property="extCode" label="货号" width="150">
        <template slot-scope="{ row,$index }">
          <el-form :ref="`extCodeFormRef_${$index}`" :model="row">
            <el-form-item prop="extCode" class="extCodeFormItem" :rules="{ validator: validateSkcExtCode }">
                <el-input v-model="row.extCode"></el-input>
            </el-form-item>
          </el-form>
        </template>
      </el-table-column>
      <!-- <el-table-column property="" label="操作" width="100">
        <template slot-scope="{ row }">
          <el-link type="danger">删除</el-link>
        </template>
      </el-table-column> -->
    </el-table>
    <div class="tips">因平台接口限制，此表格不支持BOM单录入，如有需要请到TEMU商家后台完善BOM单</div>
  </div>
</template>
  
<script>
import CarouselImages from './CarouselImages.vue';

import { LANGUAGE_MAP } from '@/dictionary/i18n.js'
import { cloneDeep, isEmpty } from 'lodash';
import MutiImgUpload from '@/components/Uploads/MutiImgUpload';
import { validateSkcExtCode } from '../rules.js'
export default {
  name: 'SkcCarouselImageList',
  components: { CarouselImages,MutiImgUpload },
  props: {
    languages:{
      type:Array,
      default(){
        return ['en']
      }
    },
    skcSpec: {
      type: Object,
      default() {
        return {};
      },
    },
    isCheckImg:{
      type:Boolean,
      default:true
    },
    autoCropImageParams:{
      type: Object,
      default() {
        return {};
      },
    },
  },

  data() {
    return {
      languageMap:LANGUAGE_MAP,
      tableData: [],
    };
  },
  computed:{
    carouselImagesLimits(){
      return {
        limitSize: this.isCheckImg ? 2 * 1024 * 1024 : null,
        limitHeight: this.isCheckImg ? [1785, 0]:[0,0],
        limitWidth: this.isCheckImg ? [1340, 0]:[0,0],
        limitNums: 10,
        aspectRatio: this.isCheckImg ? [0.75]:0,
        aspectRatioText: '3:4',
        cropDefaultSize: [1500, 2000],
        imgNames: [],
        isChange: false,
      }
    }
  },
  watch: {
    skcSpec: {
      handler(v, oldV) {
        if (isEmpty(v)) return;
        this.isChange = false;
        this.tableData = v.values.map(specV => {
          const previewImgUrls = specV.extendValues?.product_skc?.previewImgUrls || [];
          return {
            value: specV.value,
            previewImgUrls,
            extCode: specV.extendValues?.product_skc?.extCode || '',
          };
        });
      },
      immediate: true,
      deep: true,
    },
    tableData: {
      handler(v, oldV) {
        if(this.isChange){
          this.$emit('change', cloneDeep(this.tableData));
        }
        this.isChange = true;
      },
      deep: true,
    },
  },
  methods: {
    async validate() {
      if (!this.tableData.length) {
        return true;
      }
      try {
        const results = await Promise.all(
          this.tableData.map(async (row, index) => {
            const ref = this.$refs[`carouselImagesRef_${index}`];
            const extCodeRef = this.$refs[`extCodeFormRef_${index}`]
            // 兼容 validate 返回 Promise 或同步值
            const valid = ref && typeof ref.validate === 'function' ? await ref.validate() : true;
            let extCodeValid = true
            if(extCodeRef){
              extCodeValid = extCodeRef.validate()
            }
            return Promise.resolve(valid && extCodeValid);
          })
        );
        return results.every(result => result);
      } catch (e) {
        console.log('validate has Error', e);
        return false;
      }
    },
    validateSkcExtCode(rule, value, callback){
      return validateSkcExtCode(rule, value, callback)
    }
  },
};
</script>
  
<style lang="scss" scoped>
.input-number {
  .el-input__inner {
    text-align: left;
  }
}
.tips{
  font-size: 12px;
  color: #909399;
}
.extCodeFormItem{
  padding-bottom: 30px;
}
</style>